module.exports = __webpack_public_path__ + "img/dog_standing_icon_v2.cc048423.svg";